import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    consumePaymentSessionReturn,
    peekStripeSetupRedirect,
} from '../utils/stripeSetupConfirm';
import './FormMagicLinkLanding.css';

const PaymentMethodReturnLanding = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [error, setError] = useState(null);

    useEffect(() => {
        peekStripeSetupRedirect(searchParams);
        const token = consumePaymentSessionReturn();
        if (!token) {
            setError(
                'This payment session could not be restored. Please use the original payment link from your email.',
            );
            return;
        }
        navigate(`/payment/${encodeURIComponent(token)}`, { replace: true });
    }, [navigate, searchParams]);

    if (error) {
        return (
            <div className="form-magic-page">
                <div className="form-magic-card form-magic-error">
                    <h2>Link unavailable</h2>
                    <p>{error}</p>
                    <p>
                        Email <a href="mailto:support@keyflo.ai">support@keyflo.ai</a>
                        {' '}to request a new payment link.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="form-magic-page">
            <div className="form-magic-card">Finishing payment setup…</div>
        </div>
    );
};

export default PaymentMethodReturnLanding;
